<template>
  <div>

    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          รายงานความก้าวหน้า
        </div>
        <div class="d-flex align-center">
          <Iconify
              icon="ion:document-text"
              color="var(--theme-color-one)"
              class="mr-3"
          ></Iconify>
          <div>รายงานความก้าวหน้าที่ส่ง</div>
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center" style="max-width: 190px">
            <div>สถานะ</div>
            <SelectBox
                placeholder="สถานะ"
                hide-details
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="search"
            ></TextField>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in tableHeader"
            :key="i"
            :style="{ 'width': item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <ProgressReportItem
            v-for="(item, i) in plans"
            :key="i"
            :item="item"
            :index="i"
            :headers="tableHeader"
            @onUpdateStatus="(status) => onUpdateStatus(status, item.id)"
        ></ProgressReportItem>
      </div>
    </div>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import SelectBox from "../../components/input/SelectBox"
import ProgressReportItem from "../../components/ProgressReportItem"
import { mapState } from "vuex"

export default {
  name: "ProgressReportList",
  components: {
    TextField,
    SelectBox,
    ProgressReportItem
  },
  data () {
    return {
      tableHeader: [
        {
          name: '',
          width: '6%'
        },
        {
          name: 'ลำดับ',
          width: '6%'
        },
        {
          name: 'รหัสโครงการ',
          width: '8%'
        },
        {
          name: 'ชื่อโครงการ',
          width: '25%'
        },
        {
          name: 'เเผนงานที่ยื่น',
          width: '25%'
        },
        {
          name: 'ผู้นำเข้าข้อมูล',
          width: '10%'
        },
        {
          name: 'ระยะเวลา',
          width: '10%'
        },
        {
          name: 'สถานะ',
          width: '10%'
        }
      ],
      plans: [
        // {
        //   plan_code: '#0127',
        //   project_name_th: 'โครงการพัฒนาเครื่องมือโดรน...',
        //   form: 'แผนงานพัฒนาขีดความสามารถทาง...',
        //   importBy: 'จักรภัทร',
        //   doc_status: 'ฉบับร่าง'
        // },
        // {
        //   plan_code: '#0127',
        //   project_name_th: 'โครงการพัฒนาเครื่องมือโดรน...',
        //   form: 'แผนงานพัฒนาขีดความสามารถทาง...',
        //   importBy: 'จักรภัทร',
        //   doc_status: 'รอพิจารณา'
        // },
        // {
        //   plan_code: '#0127',
        //   project_name_th: 'โครงการพัฒนาเครื่องมือโดรน...',
        //   form: 'แผนงานพัฒนาขีดความสามารถทาง...',
        //   importBy: 'จักรภัทร',
        //   doc_status: 'ไม่ผ่านพิจารณา'
        // }
      ]
    }
  },
  created () {
    this.getFormCList()
  },
  computed: {
    ...mapState({
      isUSP: state => state.Auth.User.user_type === 'USP',
      isRSP: state => state.Auth.User.user_type === 'RSP'
    })
  },
  methods: {
    async getFormCList () {
      let res
      let payload = {
        status: 'Draft,Submitted,Approved',
        doc_type: 'Progress,Final'
      }

      if (this.isRSP) payload.status = 'Submitted,Approved'

      res = await this.$apiFire('CForm/getFormCList', payload)
      console.log(res)
      this.plans = res
    },
    async onUpdateStatus (status, id) {
      let payload = {
        id,
        payload: {
          status
        }
      }

      let res = await this.$apiFire('CForm/updateFormC', payload)
      this.getFormCList()
    }
  }
}
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>